import React from 'react'
import { Pager, ActionIcon, Button, View } from '@/components'
import { useIsMobile, useOnboarding } from '@/hooks'
import { Page } from './Page'
import { onboardingPages } from './pages'
import { createStyles } from '@codeleap/styles'
import { modal } from '@codeleap/modals'

export const OnboardingModal = modal({ id: 'onboarding' }).content(({ toggle }) => {
  const { page, next, previous, finish } = useOnboarding()
  const isMobile = useIsMobile()

  const isFirst = page <= 0

  const handleNext = async () => {
    const isLast = page >= onboardingPages?.length - 1

    if (isLast) {
      toggle()
      await finish()
    } else {
      next()
    }
  }

  OnboardingModal.useProps({
    style: [isMobile && 'fullscreen', 'centered', { box: styles.modalBox, body: styles.modalBody }],
    showClose: false,
  }, [isMobile])

  return <>
    <ActionIcon
      debugName={`onboarding:closeButton`}
      name={'x'}
      style={['minimal', 'primarySolid300', 'alignSelfEnd', 'absolute', 'iconSize:3', styles.close]}
      onPress={toggle}
    />

    {/* @ts-ignore */}
    <Pager
      debugName='pager:onboarding'
      disableSwipe
      dots
      dotsDisabled
      page={page}
      onChange={() => null}
      style={[styles.pagerWrapper, { wrapper: styles.pager }]}
      footer={
        <View
          style={[
            'fullWidth',
            'center',
            'paddingHorizontal:4',
            'paddingTop:4',
            'marginBottom:4',
            'gap:2',
            {
              breakpoints: { mobile: ['paddingHorizontal:2', 'marginBottom:2', 'paddingTop:2', 'column'] },
            },
          ]}
        >
          <Button
            style={['pill', 'padding:1', 'fullWidth']}
            debugName='onboardingPager:button'
            text={'Previous'}
            onPress={previous}
            disabled={isFirst}
            debounce={500}
          />
          <Button
            style={['pill', 'padding:1', 'fullWidth']}
            debugName='onboardingPager:button'
            text={'Next'}
            onPress={handleNext}
            debounce={500}
          />
        </View>
      }
    >
      {onboardingPages.map((page, index) => {
        return <Page key={'onboardingPager-' + page.title + index} {...page} />
      })}
    </Pager>
  </>
})

const MODAL_WIDTH = 700

const styles = createStyles(theme => ({
  modalBox: {
    ...theme.spacing.padding(0),
    borderRadius: theme.radius.large,
    width: MODAL_WIDTH,
    maxWidth: `calc(100vw - ${theme.spacing.value(4)}px)`,
    [theme.media.down('mobile')]: {
      position: 'fixed',
      overflowY: 'auto',
      ...theme.presets.fullWidth,
      height: '100%',
      borderRadius: 0,
      maxWidth: `100vw`,
    },
  },
  modalBody: {
    [theme.media.down('mobile')]: {
      height: '100%',
      maxHeight: 'none',
    },
  },
  close: {
    ...theme.presets.absolute,
    top: theme.spacing.value(4),
    right: theme.spacing.value(4),
    zIndex: 1,
  },
  pager: {
    paddingBottom: theme.spacing.value(4),

    [theme.media.down('mobile')]: {
      ...theme.presets.justifySpaceBetween,
      height: '100svh',
      position: 'fixed',
      overflowY: 'auto',
      paddingBottom: theme.spacing.value(2),
    },
  },
  pagerWrapper: {
    [theme.media.down('mobile')]: {
      height: '100svh',
      position: 'fixed',
      overflowY: 'auto',
    },
  },
}))